"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using angle brackets with percent signs (`<%` `%>`).
 * Matches tags of the form `<%variable%>` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello <%variable%>';
 * const result = replaceTags(text, { variable: 'world' }, AngleBracketsWithPercentSigns);
 * console.log(result); // Output: 'Hello world'
 */
var AngleBracketsWithPercentSigns = {
    name: "Angle Brackets With Percent Signs",
    openingTag: "<%",
    closingTag: "%>",
    tagPattern: /<%([^%]+)%>/g,
    tagStartPattern: /^<%/,
    tagEndPattern: /%>$/,
};
exports.default = AngleBracketsWithPercentSigns;
